The URL of the advertisement branding image.

This can be retrieved to visually identify an advertisement branding in a partner system.
